const DEFAULT_CALLBACK_URL = "/";
const LOCAL_BASE_ORIGIN = "https://salesably.local";
const URL_SCHEME_PATTERN = /^[a-zA-Z][a-zA-Z\d+.-]*:/;
const CONTROL_CHARACTER_PATTERN = /[\u0000-\u001F\u007F]/;

export function getSafeCallbackUrl(
  candidate,
  fallback = DEFAULT_CALLBACK_URL,
  baseOrigin = LOCAL_BASE_ORIGIN
) {
  const safeFallback = getSafeInternalPath(fallback) || DEFAULT_CALLBACK_URL;
  if (typeof candidate !== "string") return safeFallback;

  const value = candidate.trim();
  if (!value || value.length > 2048) return safeFallback;
  if (CONTROL_CHARACTER_PATTERN.test(value)) return safeFallback;
  if (value.startsWith("//") || value.includes("\\")) return safeFallback;

  const isAbsoluteUrl = URL_SCHEME_PATTERN.test(value);
  if (!isAbsoluteUrl && !value.startsWith("/")) return safeFallback;

  try {
    const base = new URL(baseOrigin || LOCAL_BASE_ORIGIN);
    const parsed = new URL(value, base);
    if (parsed.origin !== base.origin) return safeFallback;

    return getSafeInternalPath(
      `${parsed.pathname}${parsed.search}${parsed.hash}`
    ) || safeFallback;
  } catch {
    return safeFallback;
  }
}

function getSafeInternalPath(value) {
  if (typeof value !== "string") return null;

  const candidate = value.trim();
  if (!candidate || candidate.startsWith("//") || candidate.includes("\\")) {
    return null;
  }

  if (!candidate.startsWith("/")) return null;

  try {
    const parsed = new URL(candidate, LOCAL_BASE_ORIGIN);
    if (parsed.origin !== LOCAL_BASE_ORIGIN) return null;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}
